import React, { useState } from "react";
import { Link } from "react-router-dom";
import MiniCategoriList from "./MiniCategoriList"
import MiniSubCategories from "./MiniSubCategories"

const MiniCategories = () => {
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  return (
    <>
      <div className="display-mini display-mob">
        <div className="d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href="/HomePage">
                <i className="ri-arrow-left-s-line fs-3 me-1 text-black"></i>
              </a>
            </li>
          </div>
          <div className="d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>

        <div className="d-flex align-items-start pt-6">
          <MiniCategoriList selectedCategory={selectedCategory} onSelect={setSelectedCategory} />
          <MiniSubCategories selectedCategory={selectedCategory} />
        </div>

        {/* Deals / Digital / Ref Products row */}
        <div className="d-flex justify-content-start gap-4 px-3 py-3 border-top">
          <Link to="/DealsPage" className="text-center text-nowrap text-decoration-none">
            <img
              alt="Deals"
              src="https://www.shutterstock.com/image-vector/special-offer-banner-sale-template-260nw-2473501733.jpg"
              className="avatar avatar-lg rounded-circle object-fit-cover"
            />
            <div className="mt-1">
              <span className="nav-link text-xxxs fw-normal text-black letter-spacing-1">Deals</span>
            </div>
          </Link>
          <Link to="/DigitalProduct" className="text-center text-nowrap text-decoration-none">
            <img
              alt="Digital Product"
              src="https://img.freepik.com/premium-vector/digital-product-shopping-bag-logo-online-store_1019841-74.jpg?semt=ais_incoming&w=740&q=80"
              className="avatar avatar-lg rounded-circle object-fit-cover"
            />
            <div className="mt-1">
              <span className="nav-link text-xxxs fw-normal text-black letter-spacing-1">Digital Product</span>
            </div>
          </Link>
          <Link to="/RefProducts" className="text-center text-nowrap text-decoration-none">
            <img
              alt="Ref Products"
              src="../../assets/img/refProduct.jpg"
              className="avatar avatar-lg rounded-circle object-fit-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = "../../assets/img/categories/allcategories.png"; }}
            />
            <div className="mt-1">
              <span className="nav-link text-xxxs fw-normal text-black letter-spacing-1">Ref Products</span>
            </div>
          </Link>
        </div>
      </div>
    </>
  )
}

export default MiniCategories
